import { render, staticRenderFns } from "./StatsTableROI.vue?vue&type=template&id=8f730404&scoped=true&"
import script from "./StatsTableROI.vue?vue&type=script&lang=js&"
export * from "./StatsTableROI.vue?vue&type=script&lang=js&"
import style1 from "./StatsTableROI.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f730404",
  null
  
)

export default component.exports